export default {
  PREFERRED_MEANS_OF_CONTACT_COMMAND: Symbol.for('PREFERRED_MEANS_OF_CONTACT_COMMAND'),
  PREFERRED_MEANS_OF_CONTACT_REPOSITORY: Symbol.for('PREFERRED_MEANS_OF_CONTACT_REPOSITORY'),
};
